import axios from "./axios";

export const wishlistService = {
  fetchWishlist: async (userId, rowsPerPage,page) => {
    let isPage = page ==='all'? `` : `&current_page=${page}`;
    let isRowsPerPage =
      rowsPerPage === "all" ? "" : `&page_size=${rowsPerPage}`;

    let url = `/wishlist/list?user_id=${userId}${isPage ? isPage : ""}${
      isRowsPerPage ? isRowsPerPage : ""
    }`;
    try {
      const response = await axios.get(`${url}`);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  addToWishlist: async (data) => {
    try {
      const response = await axios.post("/wishlist", data);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  updateWishlistItem: async (itemId, data) => {
    try {
      const response = await axios.put(`/wishlist/${itemId}`, data);
      return response;
    } catch (error) {
      return error.response;
    }
  },

  removeFromWishlist: async (itemId) => {
    try {
      const response = await axios.delete(`/wishlist/${itemId}`);
      return response;
    } catch (error) {
      return error.response;
    }
  },
};
